function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paste-from-office/normalizers/googledocsnormalizer
 */
import { UpcastWriter } from 'ckeditor5/src/engine';
import removeBoldWrapper from '../filters/removeboldwrapper';
import { unwrapParagraphInListItem } from '../filters/list';
var googleDocsMatch = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
/**
 * Normalizer for the content pasted from Google Docs.
 *
 * @implements module:paste-from-office/normalizer~Normalizer
 */

var GoogleDocsNormalizer =
/*#__PURE__*/
function () {
  /**
   * Creates a new `GoogleDocsNormalizer` instance.
   *
   * @param {module:engine/view/document~Document} document View document.
   */
  function GoogleDocsNormalizer(document) {
    _classCallCheck(this, GoogleDocsNormalizer);

    /**
     * @readonly
     * @type {module:engine/view/document~Document}
     */
    this.document = document;
  }
  /**
   * @inheritDoc
   */


  _createClass(GoogleDocsNormalizer, [{
    key: "isActive",
    value: function isActive(htmlString) {
      return googleDocsMatch.test(htmlString);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute(data) {
      var writer = new UpcastWriter(this.document);
      removeBoldWrapper(data.content, writer);
      unwrapParagraphInListItem(data.content, writer);
    }
  }]);

  return GoogleDocsNormalizer;
}();

export { GoogleDocsNormalizer as default };